import { useEffect, useRef } from 'react';

const MAX_FILTERED_AUTO_LOAD_PAGES = 10;

function isLibraryContentScrollable(
  container: HTMLElement | null,
  embedded: boolean,
): boolean {
  if (embedded) {
    if (!container) {
      return false;
    }

    return container.scrollHeight > container.clientHeight + 1;
  }

  return document.documentElement.scrollHeight > window.innerHeight + 1;
}

export function useAutoLoadAssetsWhenFiltered({
  container,
  embedded,
  enabled,
  isLoading,
  onLoadMore,
  contentVersion,
  filterKey,
}: {
  container: HTMLElement | null;
  embedded: boolean;
  enabled: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  contentVersion: number;
  filterKey: string;
}) {
  const autoLoadsRef = useRef(0);

  useEffect(() => {
    autoLoadsRef.current = 0;
  }, [filterKey]);

  useEffect(() => {
    if (
      !enabled ||
      isLoading ||
      autoLoadsRef.current >= MAX_FILTERED_AUTO_LOAD_PAGES
    ) {
      return;
    }

    if (embedded && !container) {
      return;
    }

    if (isLibraryContentScrollable(container, embedded)) {
      return;
    }

    autoLoadsRef.current += 1;
    onLoadMore();
  }, [
    container,
    contentVersion,
    embedded,
    enabled,
    filterKey,
    isLoading,
    onLoadMore,
  ]);
}
